var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar',{attrs:{"data":_vm.data,"logo-url":_vm.urlGenerator('/'),"logo-src":_vm.urlGenerator(_vm.logoUrl),"logo-icon-src":_vm.urlGenerator(_vm.iconUrl)}})
}
var staticRenderFns = []

export { render, staticRenderFns }